import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import Mixpanel from "utils/mixpanel";
import { combineArrayOfWordsWithCommasAndAnAndForLastItem } from "utils/utils";
import { getTestKitDisplayName } from "utils/v3/testKitUtils";
import {
  selectExistingOrdersWithoutCancelled,
  selectTestKitsGLIsCurrentlyOffering
} from "store/reducers/order/OrderInformationSlice";
import LoadIcon from "assets/images/LoadIcon.svg";
import WelcomeHero from ".";
import { Kit } from "types/kit";

type TestingInProgressHeroProps = {};

const TestingInProgressHero: React.FC<TestingInProgressHeroProps> = () => {
  const kitsGLCurrentOffers = useSelector(selectTestKitsGLIsCurrentlyOffering);
  const kitOrders = useSelector(selectExistingOrdersWithoutCancelled);
  const ordersForKitsThatAreSubmittedButNotCompleteYet = kitOrders.filter(
    (order: Kit) => {
      return order.documentIds?.length === 0;
    }
  );

  const testNamesArray = ordersForKitsThatAreSubmittedButNotCompleteYet?.map(
    (order: Kit) => {
      return getTestKitDisplayName({
        kit: order,
        kits: kitsGLCurrentOffers
      });
    }
  );

  const testNamesString = combineArrayOfWordsWithCommasAndAnAndForLastItem(
    testNamesArray
  );
  const onActionClick = useCallback(() => {
    Mixpanel.track(`To Do Card CTA Clicked - Testing in progress`);
  }, [Mixpanel]);

  return (
    <WelcomeHero
      headerIcon={LoadIcon}
      headerSubText="Don't forget to send your samples back!"
      headerText="Testing in Progress"
      onActionClick={onActionClick}
      id="testing-in-progress-hero"
      tooltipContent={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="body_sm_white">
            {`You have ${testNamesString} testing in progress.`}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body_strong_sm_white">
              What can you expect?
            </Typography>
            <Box
              component="ul"
              sx={{ margin: 0, padding: 0, paddingLeft: 2.5 }}
            >
              <Box component="li">
                <Typography variant="body_sm_white">
                  You'll receive sample collection kit(s) in the mail, please
                  return them promptly.
                </Typography>
              </Box>
              <Box component="li">
                <Typography variant="body_sm_white">
                  Your results will be ready shortly after your samples are
                  received by our partner lab(s).
                </Typography>
              </Box>
              <Box component="li">
                <Typography variant="body_sm_white">
                  If you have a medically significant finding, we recommend that
                  you meet with a genetic counselor, as appropriate, to help
                  explain your results. This consultation is provided at no
                  additional cost.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      }
    />
  );
};

export default TestingInProgressHero;
